import React, { useContext, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { PipeLineContext } from "../PipeLineContext";
import Formulario from "../../../../../Components/Cadastro/Formulario/Formulario";
import FormularioComplementar from "../../../../../Components/Cadastro/FormularioComplementar/FormularioComplementar";
import DataTable from "../../../../../Components/DataTable/DataTable";

const FormularioPipeLine = () => {
  const {
    values,
    setValues,
    getDetailHandler,
    removerConsultor,
    adionarConsultor,
    removerTipoAgendamento,
    adionarTipoAgendamento,
  } = useContext(PipeLineContext);
  let { id } = useParams();

  useEffect(() => {
    getDetailHandler(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      data: {
        ...values.data,
        [name]: value,
      },
    });
  }

  function onChangeInputConsultores(event) {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setValues({
      ...values,
      dataConsultor: {
        id: value,
        usuarioId: value,
        usuarioNome: text,
      },
    });
  }

  function onChangeInputTipoAgendamento(event) {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setValues({
      ...values,
      dataTipoAgendamento: {
        id: value,
        tipoAgendamentoId: value,
        tipoAgendamentoDescricao: text,
      },
    });
  }
  return (
    <Fragment>
      <Formulario context={PipeLineContext}>
        <div className="col-12 col-md-3 form-group">
          <label>Código</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength={50}
            name="pipeLineCodigo"
            value={values.data.pipeLineCodigo}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-7 form-group">
          <label>Descrição</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength={250}
            name="pipeLineDescricao"
            value={values.data.pipeLineDescricao}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-2 form-group">
          <label>Status</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="pipeLineAtivo"
            value={values.data.pipeLineAtivo}
            onChange={onChangeInput}
          >
            <option className="disabled"></option>
            <option value="S"> Ativo </option>
            <option value="N"> Inátivo </option>
          </select>
        </div>

      </Formulario>
      <FormularioComplementar titulo="Tipos Agendamento">
        <div className="col-12 col-md-3 form-group">
          <label>Tipo Agendamento</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="tipoAgendamentoId"
            value={values.dataTipoAgendamento.tipoAgendamentoId}
            onChange={onChangeInputTipoAgendamento}
          >
            <option className="disabled"></option>
            {values.tiposAgendamento.map((tipoAgendamento) => (
              <option key={tipoAgendamento.tipoAgendamentoId} value={tipoAgendamento.tipoAgendamentoId}>
                {tipoAgendamento.tipoAgendamentoDescricao}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-2 form-group">
          <button
            disabled={!values.dataTipoAgendamento.tipoAgendamentoId}
            type="button"
            className="btn btn-default buttonFormularios"
            onClick={adionarTipoAgendamento}
          >
            Adicionar
          </button>
        </div>
        <div className="col-12 col-md-12 form-group">
          <DataTable
            data={values.tiposAgendamentoPipeLine}
            columnsDefinition={values.columnsDefinitionTiposAgendamento}
            removeHandler={values.formDisabled ? null : removerTipoAgendamento}
          />
        </div>
      </FormularioComplementar>
      <FormularioComplementar titulo="Consultores">
        <div className="col-12 col-md-3 form-group">
          <label>Consultor</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="usuarioId"
            value={values.dataConsultor.usuarioId}
            onChange={onChangeInputConsultores}
          >
            <option className="disabled"></option>
            {values.usuarios.map((usuario) => (
              <option key={usuario.usuarioId} value={usuario.usuarioId}>
                {usuario.usuarioNome}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-2 form-group">
          <button
            disabled={!values.dataConsultor.usuarioId}
            type="button"
            className="btn btn-default buttonFormularios"
            onClick={adionarConsultor}
          >
            Adicionar
          </button>
        </div>
        <div className="col-12 col-md-12 form-group">
          <DataTable
            data={values.consultoresPipeLine}
            columnsDefinition={values.columnsDefinitionConsultores}
            removeHandler={values.formDisabled ? null : removerConsultor}
          />
        </div>
      </FormularioComplementar>
    </Fragment>
  );
};

export default FormularioPipeLine;
